import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { SxHttpService } from './sxHttp.service';

@Injectable()
export class VentaAsyncService {
  private url = 'api/ventaAsync';

  constructor(private sxHttp: SxHttpService) { }

  getVentaAsync(idVentaAsync,systemCode): Observable<any> {
    const url = `${this.url}/${idVentaAsync}/${systemCode}`;
    return this.sxHttp.get(url)
      .map(response => {
        return response.json().data;
      });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/ventaAsync.service.ts